import { floor } from 'lodash';
import { Numeric } from './typescript';

export const getBMI = (weightInKG: Numeric, heightInCM: Numeric) => {
  const heightInM = Number(heightInCM) / 100.0;
  const bmi = Number(weightInKG) / (heightInM * heightInM);
  return floor(bmi, 1);
}
